'use strict';

/**
 * Because THREE.Color is RGB only.
 */
export class Color4 {
  r: number;
  g: number;
  b: number;
  a: number;

  constructor(r: number = 0, g: number = 0, b: number = 0, a: number = 0) {
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
  }

  clone(): Color4 {
    return new Color4(this.r, this.g, this.b, this.a);
  }

  add(color: Color4): this {
    this.r += color.r;
    this.g += color.g;
    this.b += color.b;
    this.a += color.a;
    return this;
  }

  multiplyScalar(scalar: number): this {
    this.r *= scalar;
    this.g *= scalar;
    this.b *= scalar;
    this.a *= scalar;
    return this;
  }
}
